<template>
  <div class="information-section scrollbar no-scrollbar flex -mr-5 mb-5 pr-5 gap-2 sm:mr-0 sm:pr-0 md:mb-15 md:gap-5">
    <div v-for="section in sections" :key="section.name" class="information-content" :class="section.contentClass">
      <div class="text-section px-5 py-10 md:pl-10 md:pr-5">
        <p class="font-500 text-2xl text-gray-10 mb-4">{{ section.contentText }}</p>
        <div class="flex gap-2">
          <template v-for="btn in section.btns" :key="btn.text">
            <locale-link :to="btn.link" :target="section.linkTarget">
              <etg-button size="small" class="bg-gray-10" :class="section.btnClass">
                {{ btn.text }}
              </etg-button>
            </locale-link>
          </template>
        </div>
      </div>
      <etg-img class="!items-end" :src="section.imgSrc" />
    </div>
  </div>
</template>

<script lang="ts" setup>
const { t } = useI18n()
const { iosLink, androidLink } = useDownloadLinks()

const sections = computed(() => [
  {
    name: 'new-promo',
    contentClass: 'bg-orange-50',
    contentText: t('home.new_promo.content'),
    btnClass: 'text-orange-50',
    btns: [
      { text: t('general_android_app'), link: androidLink.value },
      { text: t('general_ios_app'), link: iosLink.value },
    ],
    linkTarget: '_blank',
    imgSrc: '@/assets/images/marketing/home-new-promo.svg',
  },
  {
    name: 'about-eatigo',
    contentClass: 'bg-pink-50',
    contentText: t('home.about_eatigo.content'),
    btnClass: 'text-pink-50',
    btns: [{ text: t('home.about_eatigo.button'), link: '/about-us' }],
    linkTarget: '_self',
    imgSrc: '@/assets/images/marketing/home-about-eatigo.svg',
  },
])
</script>

<style lang="scss" scoped>
.information-content {
  @apply flex-1 grid grid-rows-2 rounded min-w-full aspect-0.85 sm:min-w-auto sm:aspect-auto md:grid-rows-1 md:grid-cols-2;
}
</style>
